module.exports = __webpack_public_path__ + "img/企业使命.f5822e3d.png";